<template>
    <v-app>
        <main>
            <h1 class="text-center pt-5">
                🍕 Жряка - оптимальная пицца в Питере
            </h1>
            <v-content v-if="loading">
                <v-container class="grey lighten-5">
                    <v-row class="pizza-card">
                        <v-progress-circular :size="70"
                                             :width="7"
                                             indeterminate></v-progress-circular>
                    </v-row>
                </v-container>
            </v-content>
            <v-content v-else>
                <v-container class="grey lighten-5">
                    <v-row>
                        <v-col v-for="pizza in pizzas"
                               :key="pizza.orderUrl + pizza.price"
                               cols="12"
                               sm="6"
                               md="4"
                               lg="3">
                            <PizzaCard :pizza="pizza" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-content>
        </main>
        <footer>
            <a href="mailto:kasthack@epicm.org">Связаться</a>
        </footer>
    </v-app>
</template>

<script>
    import PizzaCard from './components/PizzaCard';

    export default {
        name: 'App',

        components: {
            PizzaCard,
        },
        created() {
            this.getDataFromApi()
        },
        data() {
            return {
                loading: false,
                pizzas: []
            }
        },
        methods: {
            getDataFromApi() {
                this.loading = true
                axios.get('api/Pizza/all')
                    .then(response => {
                        this.loading = false;
                        this.pizzas = response.data;
                    })
                    .catch(error => {
                        this.loading = false;
                    })
            }
        }
    };
</script>
